import { useParams } from 'react-router-dom';
import { GAME_REGISTRY } from '@/games/gameRegistry';
import { NotFoundPage } from './routes';

/**
 * Renders whichever page GAME_REGISTRY maps the URL's :gameSlug to.
 * Unknown slugs render the same Not Found page as the wildcard route.
 */
const GameRoute = () => {
  const { gameSlug } = useParams<{ gameSlug: string }>();
  // Own keys only, so /constructor or /toString can't resolve to Object.prototype members.
  const GamePage =
    gameSlug && Object.prototype.hasOwnProperty.call(GAME_REGISTRY, gameSlug)
      ? GAME_REGISTRY[gameSlug]
      : undefined;

  if (!GamePage) {
    return <NotFoundPage />;
  }

  return <GamePage />;
};

export default GameRoute;
